import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import { getRealShowOption, inputChecker, resetAnwsers, getSampleGroupOpts } from '@/utilities/quest';
import { getLocalText } from '@/utilities/language';
import { randomArray, randomShowOptions } from '@/utilities/common';
var defaultAnswer = {
  selected: [],
  text: '',
  type: 'multi'
};
var MultiChoice = /*#__PURE__*/function (_Component) {
  _inherits(MultiChoice, _Component);
  function MultiChoice(props) {
    var _custom$sampleGroups;
    var _this;
    _classCallCheck(this, MultiChoice);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiChoice).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var _this$props = _this.props,
        question = _this$props.question,
        quotaStrategy = _this$props.quotaStrategy;
      var disabledOpts = quotaStrategy === null || quotaStrategy === void 0 ? void 0 : quotaStrategy.optionsQuota.filter(function (q) {
        return !q.remaining;
      });
      var _this$state = _this.state,
        realShowOptions = _this$state.realShowOptions,
        isFocus = _this$state.isFocus;
      if ((disabledOpts === null || disabledOpts === void 0 ? void 0 : disabledOpts.length) === realShowOptions.length && question.required) {
        _this.setState({
          errorOption: ''
        });
        callback();
        return; // 全部选项满额的时候就不检查了
      }
      var _question$custom = question.custom,
        min = _question$custom.min,
        max = _question$custom.max,
        options = _question$custom.options;
      if (answer.selected.length !== 0 && (!isFocus && min && answer.selected.length < min || max && answer.selected.length > max)) {
        // callback(`需要选择多于${min}个小于${max}个答案`);
        _this.setState({
          errorOption: ''
        });
        callback(getLocalText('MultiChoice.min.or.max', min || +question.required, max || options.length + +(question.custom.other.status !== 0)));
      }
      if (max && answer.selected.length == max) {
        var params = [];
        realShowOptions.forEach(function (option) {
          if (answer.selected.indexOf(option.id) < 0) {
            params.push(option.id);
          }
          _this.setState({
            overDisabledIds: params
          });
        });
      } else {
        _this.setState({
          overDisabledIds: []
        });
      }
      if (question.required && answer.selected.length === 0) {
        _this.setState({
          errorOption: ''
        });
        callback(getLocalText('SingleChoice.Selected'));
        return;
      }
      var otherRequired = question.custom.other.status === 2;
      var otherChecked = answer.selected.includes('other');
      var textRequired = otherRequired && otherChecked;
      if (textRequired && !answer.text) {
        _this.setState({
          errorOption: 'other'
        });
        callback(getLocalText('SingleChoice.otherText'));
        return;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
      try {
        var _loop = function _loop() {
          var id = _step.value;
          if (id === 'other') {
            return "continue";
          }
          var selectedOption = realShowOptions.find(function (el) {
            return el.id === id;
          });
          if (selectedOption && selectedOption.input === 'required') {
            try {
              if (!answer.option_blank[selectedOption.id][0]) {
                _this.setState({
                  errorOption: id
                });
                callback(getLocalText('SingleChoice.Selected'));
                return {
                  v: void 0
                };
              }
            } catch (error) {
              _this.setState({
                errorOption: id
              });
              callback(getLocalText('SingleChoice.Selected'));
              return {
                v: void 0
              };
            }
          }
          var optionBlank = answer.option_blank || {};
          if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[window.showMultiLang ? "".concat(window.language, "Restrictions") : 'restrictions']) && optionBlank[selectedOption.id]) {
            var result = inputChecker(answer.option_blank[selectedOption.id][0], selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[window.showMultiLang ? "".concat(window.language, "Restrictions") : 'restrictions']);
            if (result !== true) {
              _this.setState({
                errorOption: selectedOption.id
              });
              callback(result);
              return {
                v: void 0
              };
            }
          }
        };
        for (var _iterator = answer.selected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();
          switch (_ret) {
            case "continue":
              continue;
            default:
              if (_typeof(_ret) === "object") return _ret.v;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      _this.setState({
        errorOption: ''
      });
      callback();
    });
    var _question = props.question,
      answers = props.answers,
      _quotaStrategy = props.quotaStrategy;
    var custom = _question.custom;
    _this.state = {
      options: custom.options,
      errorOption: '',
      realShowOptions: getRealShowOption({
        question: _question,
        answers: answers,
        quotaStrategy: _quotaStrategy
      }),
      realShowOptionsBack: getRealShowOption({
        question: _question,
        answers: answers,
        quotaStrategy: _quotaStrategy
      }),
      isFocus: false,
      overDisabledIds: [],
      setShowOptions: (custom.random || custom.reverse) && custom.showOptionsNum && custom.showOptionsNum > 0
    };
    if (custom.random || custom.reverse) {
      if (custom.random) {
        // 随机排序
        _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions));
      } else if (custom.reverse) {
        var actuallyReverse = Math.random() >= 0.5;
        if (actuallyReverse) {
          _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions), 'reverse');
        }
      }
      if (_this.state.setShowOptions) {
        _this.state.realShowOptions = randomShowOptions(_toConsumableArray(_this.state.realShowOptions), custom.showOptionsNum, custom.random ? 'random' : 'reverse');
      }
    }
    if (custom.group && (custom === null || custom === void 0 ? void 0 : (_custom$sampleGroups = custom.sampleGroups) === null || _custom$sampleGroups === void 0 ? void 0 : _custom$sampleGroups.length)) {
      _this.state.realShowOptions = getSampleGroupOpts({
        options: _toConsumableArray(_this.state.realShowOptions),
        custom: custom,
        answers: answers
      });
    }
    return _this;
  }
  _createClass(MultiChoice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        question = _this$props2.question,
        answers = _this$props2.answers,
        quotaStrategy = _this$props2.quotaStrategy;
      var realShowOptions = this.state.realShowOptions;
      try {
        var _answers$question$id, _answers$question$id2;
        var selected = (answers === null || answers === void 0 ? void 0 : (_answers$question$id = answers[question.id]) === null || _answers$question$id === void 0 ? void 0 : _answers$question$id.selected) || [];
        var option_blank = (answers === null || answers === void 0 ? void 0 : (_answers$question$id2 = answers[question.id]) === null || _answers$question$id2 === void 0 ? void 0 : _answers$question$id2.option_blank) || {};
        if (selected.length) {
          var newSelected = resetAnwsers({
            type: question.type,
            question: question,
            answers: answers,
            quotaStrategy: quotaStrategy,
            realShowOptions: realShowOptions
          });
          Object.keys(option_blank).forEach(function (key) {
            if (!newSelected.includes(key)) {
              delete option_blank[key];
            }
          });
          this.props.form.setFieldsValue(_defineProperty({}, question.id, {
            type: question.type,
            selected: newSelected,
            option_blank: option_blank,
            text: ''
          }));
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQ = prevProps.question;
      var nextQ = this.props.question;
      if (nextQ.optionFilter && nextQ.optionFilter[0]) {
        var _nextQ$optionFilter$ = nextQ.optionFilter[0].id.split('--matrix--'),
          _nextQ$optionFilter$2 = _slicedToArray(_nextQ$optionFilter$, 2),
          filterByQuestionId = _nextQ$optionFilter$2[0],
          lineId = _nextQ$optionFilter$2[1];
        var nowAnswers = this.props.answers;
        var prevAnswers = prevProps.answers;
        var nowThatQuestionSelectedOptionsIds = nowAnswers[filterByQuestionId] ? nowAnswers[filterByQuestionId].selected : [];
        var prevThatQuestionSelectedOptionsIds = prevAnswers[filterByQuestionId] ? prevAnswers[filterByQuestionId].selected : [];
        if (lineId) {
          if (lineId.indexOf('title') > -1) {
            lineId = lineId.slice(0, -6);
          }
          nowThatQuestionSelectedOptionsIds = nowThatQuestionSelectedOptionsIds[lineId] || [];
          prevThatQuestionSelectedOptionsIds = prevThatQuestionSelectedOptionsIds[lineId] || [];
        }
        var equal = isEqual(nowThatQuestionSelectedOptionsIds.sort(), prevThatQuestionSelectedOptionsIds.sort());
        if (!equal && !(nowThatQuestionSelectedOptionsIds.length === 0 && prevThatQuestionSelectedOptionsIds.length === 0) && !window.isReport) {
          this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
            type: this.props.question.type,
            selected: [],
            text: ''
          }));
        }
      }

      // 如果选项变了 就清空答案
      if (prevState.realShowOptions !== this.state.realShowOptions && !window.isReport) {
        this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
          type: this.props.question.type,
          selected: [],
          text: ''
        }));
      }
      // 预览模式下面始终不成立（broadcastchannel 使用JSON.stringify传递数据
      // 问卷模式下面始终成立， 问卷结构不会改变
      if (prevQ === nextQ) return;
      // 打开随机按钮
      if (!prevQ.custom.random && nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          options: randomOptions(_toConsumableArray(nextQ.custom.options))
        });
      }
      // 关闭随机按钮
      if (prevQ.custom.random && !nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          options: nextQ.custom.options
        });
      }
      // 判断是否修改了options， 但是broadcastchannell始终是深拷贝传递。所以这里不能比较地址了。
      if (JSON.stringify(nextQ.custom.options) !== JSON.stringify(prevQ.custom.options)) {
        if (nextQ.custom.random) {
          // eslint-disable-next-line
          this.setState({
            options: randomOptions(_toConsumableArray(nextQ.custom.options))
          });
        } else {
          // eslint-disable-next-line
          this.setState({
            options: nextQ.custom.options
          });
        }
      }
    }
  }, {
    key: "getSelectedChange",
    value: function getSelectedChange(selected, answer) {
      var text = answer && answer.text || '';
      var _answer$option_blank = answer.option_blank,
        option_blank = _answer$option_blank === void 0 ? {} : _answer$option_blank;
      if (!selected.includes('other')) {
        text = '';
      }
      return {
        type: this.props.question.type,
        selected: selected,
        text: text,
        option_blank: option_blank
      };
    }
  }, {
    key: "getOtherTextChange",
    value: function getOtherTextChange(text, answer) {
      var selected = (answer.selected || []).slice();
      var _answer$option_blank2 = answer.option_blank,
        option_blank = _answer$option_blank2 === void 0 ? {} : _answer$option_blank2;
      if (!selected.includes('other')) selected.push('other');
      return {
        type: this.props.question.type,
        selected: selected,
        text: text,
        option_blank: option_blank
      };
    }
  }, {
    key: "getInputChange",
    value: function getInputChange(id, input, answer) {
      var text = answer && answer.text || '';
      var selected = (answer.selected || []).slice();
      if (!selected.includes(id)) {
        selected.push(id);
      }
      var _answer$option_blank3 = answer.option_blank,
        option_blank = _answer$option_blank3 === void 0 ? {} : _answer$option_blank3;
      return {
        type: this.props.question.type,
        text: text,
        selected: selected,
        option_blank: _objectSpread({}, option_blank, _defineProperty({}, id, [input]))
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        question = _this$props3.question,
        _this$props3$answer = _this$props3.answer,
        answer = _this$props3$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props3$answer,
        quotaStrategy = _this$props3.quotaStrategy;
      var _this$state2 = this.state,
        realShowOptions = _this$state2.realShowOptions,
        isFocus = _this$state2.isFocus;
      var _question$custom2 = question.custom,
        min = _question$custom2.min,
        max = _question$custom2.max,
        options = _question$custom2.options,
        other = _question$custom2.other;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            validator: this.validator
          }]
        }),
        onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value; // 因为getFieldError无法判断error的来源，所以只能用这样的trick方法，
      // rc-form 写的真心不好
      var errorSelected;
      var errorText;
      var error = getFieldError(id);
      if (error && error[0]) {
        var _error = _slicedToArray(error, 1);
        errorSelected = _error[0];
      }
      if (error && error[0] === getLocalText('SingleChoice.Selected')) {
        var _error2 = _slicedToArray(error, 1);
        errorSelected = _error2[0];
      }
      if (error && error[0] === getLocalText('SingleChoice.otherText')) {
        var _error3 = _slicedToArray(error, 1);
        errorText = _error3[0];
      }
      if (answer.selected.length !== 0 && (!isFocus && min && answer.selected.length < min || max && answer.selected.length > max)) {
        // errorText = `需要选择多于${min}个小于${max}个答案`;
        // eslint-disable-next-line

        errorText = getLocalText('MultiChoice.min.or.max', min || +question.required, max || options.length + +(question.custom.other.status !== 0));
      }
      var overDisabledIds = [];
      if (max && answer.selected.length == max) {
        realShowOptions.forEach(function (option) {
          if (answer.selected.indexOf(option.id) < 0) {
            overDisabledIds.push(option.id);
          }
        });
      } else {
        overDisabledIds = [];
      }
      var changeAnswer = false;
      var selectedLength = answer.selected.length;
      if (selectedLength) {
        var lastOneId = answer.selected[selectedLength - 1];
        if (lastOneId === 'other') {
          var _other$mutex = other.mutex,
            mutex = _other$mutex === void 0 ? [] : _other$mutex;
          answer.selected = answer.selected.filter(function (id) {
            var result = !mutex.includes(id);
            if (!result) {
              var _answer$option_blank4;
              changeAnswer = true;
              (answer === null || answer === void 0 ? void 0 : (_answer$option_blank4 = answer.option_blank) === null || _answer$option_blank4 === void 0 ? void 0 : _answer$option_blank4[id]) && delete answer.option_blank[id];
            }
            return result;
          });
        } else {
          var _ref = options.find(function (el) {
              return el.id === lastOneId;
            }) || {},
            _mutex = _ref.mutex;
          if (_mutex) {
            answer.selected = answer.selected.filter(function (id) {
              var result = !_mutex.includes(id);
              if (!result) {
                var _answer$option_blank5;
                changeAnswer = true;
                (answer === null || answer === void 0 ? void 0 : (_answer$option_blank5 = answer.option_blank) === null || _answer$option_blank5 === void 0 ? void 0 : _answer$option_blank5[id]) && delete answer.option_blank[id];
              }
              return result;
            });
          }
        }
        var _loop2 = function _loop2(_i) {
          var id = answer.selected[_i];
          var one = options.find(function (el) {
            return el.id === id;
          });
          // 如果是other
          if (!one) {
            i = _i;
            return "continue";
          }
          // eslint-disable-next-line
          if (one.mutex && one.mutex.includes(lastOneId)) {
            var _answer$option_blank6;
            answer.selected.splice(_i, 1);
            changeAnswer = true;
            (answer === null || answer === void 0 ? void 0 : (_answer$option_blank6 = answer.option_blank) === null || _answer$option_blank6 === void 0 ? void 0 : _answer$option_blank6[id]) && delete answer.option_blank[id];
            _i--;
          }
          i = _i;
        };
        for (var i = 0; i < answer.selected.length; i++) {
          var _ret2 = _loop2(i);
          if (_ret2 === "continue") continue;
        }
        if (answer.selected.includes('other') // 如果选了other
        && lastOneId !== 'other' // 如果other不是最后一个 (最后一个的情况上面处理过了)
        && other && other.mutex && other.mutex.includes(lastOneId) // 如果other与lastOneId互斥
        ) {
          answer.selected = answer.selected.filter(function (id) {
            return id !== 'other';
          });
          changeAnswer = true;
        }
      }
      if (changeAnswer) {
        onChange(answer);
      }
      var disabledOptIds = (quotaStrategy === null || quotaStrategy === void 0 ? void 0 : quotaStrategy.optionsQuota.filter(function (q) {
        return !q.remaining;
      }).map(function (q) {
        return q.id;
      })) || [];
      var params = {
        options: realShowOptions,
        formAnswer: formAnswer,
        error: {
          selected: errorSelected,
          text: errorText,
          errorOption: this.state.errorOption
        },
        onChange: {
          selected: function selected(_selected) {
            return onChange(_this2.getSelectedChange(_selected, formAnswer));
          },
          text: function text(_text) {
            return onChange(_this2.getOtherTextChange(_text, formAnswer));
          },
          input: function input(id, _input) {
            return onChange(_this2.getInputChange(id, _input, formAnswer));
          }
        },
        disabledOptIds: disabledOptIds,
        overDisabledIds: overDisabledIds || this.state.overDisabledIds,
        min: min || +question.required,
        max: max || options.length + +(question.custom.other.status !== 0),
        realMin: min,
        realMax: max
      };
      return React.createElement("div", {
        onFocus: function onFocus() {
          return _this2.setState({
            isFocus: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            isFocus: false
          });
        }
      }, this.props.children(params));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var question = nextProps.question,
        answers = nextProps.answers,
        quotaStrategy = nextProps.quotaStrategy;
      var custom = question.custom;
      var realShowOptions = getRealShowOption({
        question: question,
        answers: answers,
        quotaStrategy: quotaStrategy
      });
      window.allQuestions.find(function (el) {
        return el.id === question.id;
      }).custom.realShowOptions = realShowOptions;
      if (realShowOptions.length !== state.realShowOptionsBack.length || realShowOptions.some(function (el) {
        return !state.realShowOptionsBack.find(function (item) {
          return item.id === el.id;
        });
      }) || realShowOptions.some(function (el) {
        return el.text !== state.realShowOptionsBack.find(function (item) {
          return item.id === el.id;
        }).text;
      })) {
        var _custom$sampleGroups2;
        var realShowOptionsBack = _toConsumableArray(realShowOptions);
        if (custom.random) {
          realShowOptions = randomArray(_toConsumableArray(realShowOptions));
        }
        if ((custom.random || custom.reverse) && state.setShowOptions) {
          realShowOptions = randomShowOptions(_toConsumableArray(realShowOptions), custom.showOptionsNum, custom.random ? 'random' : 'reverse');
          nextProps.form.setFieldsValue(_defineProperty({}, question.id, {
            type: question.type,
            selected: [],
            text: ''
          }));
        }
        if (custom.group && (custom === null || custom === void 0 ? void 0 : (_custom$sampleGroups2 = custom.sampleGroups) === null || _custom$sampleGroups2 === void 0 ? void 0 : _custom$sampleGroups2.length)) {
          realShowOptions = getSampleGroupOpts({
            options: _toConsumableArray(realShowOptions),
            custom: custom,
            answers: answers
          });
        }
        return {
          realShowOptions: realShowOptions,
          realShowOptionsBack: realShowOptionsBack
        };
      }
      return null;
    }
  }]);
  return MultiChoice;
}(Component);
export { MultiChoice as default };